<template>
    <VDialog v-model="visivel" scrollable>
        <ComandaDetalhe v-model="comandaDetalhe" :idComandaDetalhe="idComandaEscolhida"></ComandaDetalhe>  <!-- :id-cliente="comanda.cliente.id" -->
        <VCard>
            <Loading ref="loading"></Loading>
            <VCardTitle>Comandas em Aberto</VCardTitle>
            <VCardText>
                <VDataTable :headers="cabecalhos" :items="listaAbertas" item-key="nome"  :pagination.sync="paginacao">
                    <template #items="props">
                        <tr> 
                            <td>{{props.item.idNumeroManual}}</td>
                            <td>{{props.item.cliente.nome}}</td>
                           <!-- <td>{{formatarData(props.item.dataAbertura)}}</td> -->
                            <td>{{formatarHora(props.item.data)}}</td>
                            <td>{{props.item.situacao}}</td>
                            <td>{{formatarDinheiro(props.item.valorProdutos)}}</td>
                            <td>{{formatarDinheiro(props.item.valorServicos)}}</td>
                            <td>{{formatarDinheiro(props.item.valorCortesia)}}</td>
                            <td>{{formatarDinheiro(props.item.valorComanda)}}</td>
                            <td align='center'>
                                <VTooltip bottom>
                                    <VBtn :disabled="false" slot="activator" color="#A3A1A1" icon flat small
                                        @click="mostraItensComanda(props.item.id)">
                                        <VIcon>visibility</VIcon>
                                    </VBtn>
                                    <span>Detalhes da Comanda</span>
                                </VTooltip>
                            </td>
                        </tr>
                    </template>
                </VDataTable>
            </VCardText>
            <VCardActions>
                <VLayout justify-end>
                    <VBtn color="primary" @click="visivel = false">Fechar</VBtn>
                </VLayout>
            </VCardActions>
        </VCard>
    </VDialog>
</template>

<script>
    import Loading from "./Loading";
    import ApiService from "../../common/api.service";
    import alerts from "../../common/alerts";
    import datas from "../../mixins/datas";
    import numeros from "../../mixins/numeros";
    import moment from "moment"
    import ComandaDetalhe from "./ComandaDetalhe";

    export default {
        mixins: [datas, numeros],
        methods: {
            formatarHora(dataHora) {
                const momentHora = moment(dataHora, undefined, true);
                if (!momentHora.isValid()) {
                    return dataHora;
                }
                return momentHora.format("DD/MM/YYYY HH:mm"); //momentHora.format('LT');
            },
            mostraItensComanda(idComandaSelecionada) {
                //console.log(idComandaSelecionada);
              //  comandaDetalhe.idComandaDetalhe = idComandaSelecionada;
                //this.comandaDetalhe = false;
                this.idComandaEscolhida = idComandaSelecionada
                this.comandaDetalhe = true;
            }
        },
        data() {
            return {
                visivel: false,
                comandaDetalhe: false,
                idComandaEscolhida: 0,
                listaComandasAbertas: [],
                nomeCliente: "",
                paginacao: {
                    page: 1,
                    rowsPerPage: 5,
                    sortBy: 'nome',
                    descending: false
                },
                cabecalhos: [
                    {
                        text: "Comanda",
                        value: "idNumeroManual"
                    },
                    {
                        text: "Cliente",
                        value: "nome"
                    },
                    /*{
                        text: "Abertura",
                        value: "dataAbertura"
                    },*/
                    {
                        text: "Atendimento",
                        value: "data"
                    },
                    {
                        text: "Situação",
                        value: "situacao"
                    },
                    {
                        text: "Produtos",
                        value: "valorProdutos"
                    },
                    {
                        text: "Serviços",
                        value: "valorServicos"
                    },
                    {
                        text: "Cortesia",
                        value: "valorCortesia"
                    },
                    {
                        text: "Valor Total",
                        value: "valorComanda"
                    },
                    {
                        text: "Ações",
                        align: "center",
                        value: "",
                        sortable: false
                    }
                ]
            }
        },
        computed: {
            /*funcaoexterna(idParam){
                const respostas = await this.enviarEAguardarBackend([ApiService.getComanda(idParam)]);
                this.comandaLida = respostas[0].data;
                return this.comandaLida.id; 
            },*/
            listaAbertas() {
                //console.log(this.listaComandasAbertas);
                //this.listaComandasAbertas.forEach(e => e.valorServicos = funcaoexterna(e.id));
                return this.listaComandasAbertas.map(e => {
                    //console.log(e);
                    e.idNumeroManual = `${e.idNumeroManual !== null ? e.idNumeroManual : e.id}`;
                    return e;
                });
            }
        },
        props: {
            value: Boolean,
            idCliente: Number
        },
        components: {
            Loading,
            ComandaDetalhe
        },
        watch: {
            async visivel(v) {
                if (v) {
                    try {
                        [this.listaComandasAbertas] = (await this.$refs.loading.aguardarPromises([ApiService.get(`comandas/listaComandas`)])).map(r => r.data);
                    } catch (e) {
                        alerts.exibirErro('Não foi possível carregar as comandas abertas', e);
                        this.visivel = false;
                        return;
                    }
                } else {
                    this.listaComandasAbertas = [];
                }
                if (v !== this.value) {
                    this.$emit('input', v);
                }
            },
            value(v) {
                this.visivel = v;
            }
        }
    }
</script>

<style scoped>

</style>
